import * as RD from '@devexperts/remote-data-ts';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
export * from '@devexperts/remote-data-ts';
/**
 * Alias for `fold`
 */
export const match = RD.fold;
/**
 * Alias for `fold3`
 */
export const match3 = RD.fold3;
/**
 * Less strict version of `match`
 */
export const matchW = (onInitial, onPending, onFailure, onSuccess) => (ma) => {
    switch (ma._tag) {
        case 'RemoteInitial':
            return onInitial();
        case 'RemotePending':
            return onPending(ma.progress);
        case 'RemoteFailure':
            return onFailure(ma.error);
        case 'RemoteSuccess':
            return onSuccess(ma.value);
    }
};
/**
 * Alias for `matchW`
 */
export const foldW = matchW;
/**
 * Less strict version of `match3`
 */
export const match3W = (onPending, onFailure, onSuccess) => matchW(() => onPending(O.none), onPending, onFailure, onSuccess);
/**
 * Alias for `match3W`
 */
export const fold3W = match3W;
/**
 * Curried verson of `match3W`
 */
export const match3WC = (onPending) => (onFailure) => (onSuccess) => (ma) => pipe(ma, match3W(onPending, onFailure, onSuccess));
/**
 * Alias for `match3WC`
 */
export const fold3WC = match3WC;
/**
 * Extension of `match3WC` which allows the handling of `Option` values in the success case.
 */
export const match3WCOption = (onPending) => (onFailure) => (onNone) => (onSuccess) => (ma) => pipe(ma, pipe(O.foldW(onNone, onSuccess), match3WC(onPending)(onFailure)));
/**
 * Alias for `match3WCOption`
 */
export const fold3WCOption = match3WCOption;
//# sourceMappingURL=RemoteData.js.map